export const GROUP_TOUTIAO = [
  {
    title: '开关',
    key: 'switch',
    width: '82',
    type: 'basic',
    fixed: true
  },
  {
    title: '计划组',
    key: 'adGroupName',
    width: '270',
    type: 'basic',
    fixed: true
  },
  {
    title: '操作',
    key: 'control',
    width: '100',
    type: 'basic',
    fixed: true
  },
  {
    title: '推广目的',
    key: 'landingType',
    width: '80',
    type: 'basic'
  },
  {
    title: '预算(元)',
    key: 'budget',
    width: '400',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '账面消耗(元)',
    key: 'paperAmount',
    width: '116',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '实际消耗(元)',
    key: 'amount',
    width: '116',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '展示量',
    key: 'pv',
    width: '82',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '点击数',
    key: 'click',
    width: '82',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '点击率',
    key: 'clickRate',
    width: '82',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '平均点击单价',
    key: 'perClickPrice',
    width: '118',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '平均千次展示单价',
    key: 'thousandsOfDisplayCosts',
    width: '142',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '转化数',
    key: 'convertNum',
    width: '82',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '转化成本',
    key: 'convertCost',
    width: '94',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '转化率',
    key: 'convertRate',
    width: '82',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '激活数',
    key: 'activeNum',
    width: '82',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '激活成本',
    key: 'activeCost',
    width: '94',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '激活率',
    key: 'activeRate',
    width: '82',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '注册数',
    key: 'register',
    width: '82',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '注册成本',
    key: 'registerCost',
    width: '94',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '付费行为数',
    key: 'payCount',
    width: '110',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '付费金额',
    key: 'payAmount',
    width: '94',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '计划ID',
    key: 'adGroupId',
    width: '140',
    type: 'other',
    overflow: true
  },
  {
    title: '媒体',
    key: 'mediaName',
    width: '80',
    type: 'other',
    overflow: true
  },
  {
    title: '账号',
    key: 'adAccountName',
    width: '140',
    type: 'other',
    overflow: true
  },
  {
    title: '创建时间',
    key: 'createTime',
    width: '120',
    type: 'other'
  },
  {
    title: '同步时间',
    key: 'synTime',
    width: '120',
    type: 'other'
  }
]
export const GROUP_UC = [
  {
    title: '开关',
    key: 'switch',
    width: '82',
    type: 'basic',
    fixed: true
  },
  {
    title: '计划组',
    key: 'adGroupName',
    width: '270',
    type: 'basic',
    fixed: true
  },
  {
    title: '推广对象',
    key: 'adResource',
    width: '94',
    type: 'basic'
  },
  {
    title: '预算(元)',
    key: 'budget',
    width: '180',
    type: 'basic'
  },
  {
    title: '状态',
    key: 'originStatus',
    width: '90',
    type: 'basic',
    fixed: true,
    overflow: true
  },
  {
    title: '账面消耗(元)',
    key: 'paperAmount',
    width: '116',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '实际消耗(元)',
    key: 'amount',
    width: '116',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '展示量',
    key: 'pv',
    width: '82',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '点击量',
    key: 'click',
    width: '82',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '点击率',
    key: 'clickRate',
    width: '82',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '点击单价',
    key: 'perClickPrice',
    width: '118',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '千次展示均价',
    key: 'thousandsOfDisplayCosts',
    width: '142',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '激活数',
    key: 'activeNum',
    width: '82',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '激活成本',
    key: 'activeCost',
    width: '94',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '转化数',
    key: 'convertNum',
    width: '82',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '转化成本',
    key: 'convertCost',
    width: '94',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '深度转化数',
    key: 'deepBindingNum',
    width: '94',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '深度转化成本',
    key: 'deepBindCost',
    width: '120',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '首日ROI',
    key: 'day1Roi',
    width: '94',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '累计ROI',
    key: 'sumRoi',
    width: '94',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '推广组ID',
    key: 'adGroupId',
    width: '142',
    type: 'other'
  },
  {
    title: '账号',
    key: 'adAccountName',
    width: '142',
    type: 'other'
  },
  {
    title: '管理人员',
    key: 'launchOpName',
    width: '80',
    type: 'other',
    overflow: true
  },
  {
    title: '创建时间',
    key: 'createTime',
    width: '120',
    type: 'other'
  },
  {
    title: '同步时间',
    key: 'synTime',
    width: '120',
    type: 'other'
  }
]
export const GROUP_TENCENT = [
  {
    title: '开关',
    key: 'switch',
    width: '82',
    type: 'basic',
    fixed: true
  },
  {
    title: '推广计划',
    key: 'adGroupName',
    width: '270',
    type: 'basic',
    fixed: true
  },
  {
    title: '操作',
    key: 'control',
    width: '100',
    type: 'basic',
    fixed: true
  },
  {
    title: '状态',
    key: 'originStatus',
    width: '90',
    type: 'basic',
    fixed: true,
    overflow: true
  },
  {
    title: '推广目的',
    key: 'adResource',
    width: '100',
    type: 'basic'
  },
  {
    title: '推广时间',
    key: 'planTime',
    width: '100',
    type: 'basic'
  },
  {
    title: '预算(元)',
    key: 'budget',
    width: '180',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '账面消耗(元)',
    key: 'paperAmount',
    width: '116',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '实际消耗(元)',
    key: 'amount',
    width: '116',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '展示量',
    key: 'pv',
    width: '82',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '点击数',
    key: 'click',
    width: '82',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '点击率',
    key: 'clickRate',
    width: '82',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '平均点击单价',
    key: 'perClickPrice',
    width: '118',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '平均千次展示单价',
    key: 'thousandsOfDisplayCosts',
    width: '142',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '注册数',
    key: 'register',
    width: '82',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '注册成本',
    key: 'registerCost',
    width: '94',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '激活数',
    key: 'activeNum',
    width: '82',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '激活成本',
    key: 'activeCost',
    width: '120',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '激活率',
    key: 'activeRate',
    width: '82',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '转化数',
    key: 'convertNum',
    width: '82',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '转化成本',
    key: 'convertCost',
    width: '120',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '转化率',
    key: 'convertRate',
    width: '82',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '付费行为数',
    key: 'appCheckoutCount',
    width: '110',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '付费金额',
    key: 'payAmount',
    width: '94',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '计划ID',
    key: 'adGroupId',
    width: '142',
    type: 'other'
  },
  {
    title: '媒体',
    key: 'mediaName',
    width: '142',
    type: 'other'
  },
  {
    title: '账号',
    key: 'adAccountName',
    width: '142',
    type: 'other'
  },
  {
    title: '创建时间',
    key: 'createTime',
    width: '120',
    type: 'other'
  },
  {
    title: '同步时间',
    key: 'synTime',
    width: '120',
    type: 'other'
  }
]
export const GROUP_BAIDU = [
  {
    title: '开关',
    key: 'switch',
    width: '82',
    type: 'basic',
    fixed: true
  },
  {
    title: '推广计划',
    key: 'adGroupName',
    width: '270',
    type: 'basic',
    fixed: true
  },
  {
    title: '操作',
    key: 'control',
    width: '100',
    type: 'basic',
    fixed: true
  },
  {
    title: '状态',
    key: 'originStatus',
    width: '90',
    type: 'basic',
    fixed: true,
    overflow: true
  },
  {
    title: '推广对象',
    key: 'adResourceId',
    width: '100',
    type: 'basic'
  },
  {
    title: '推广日期',
    key: 'planTime',
    width: '100',
    type: 'basic'
  },
  {
    title: '日预算(元)',
    key: 'budget',
    width: '180',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '账面消耗(元)',
    key: 'paperAmount',
    width: '116',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '实际消耗(元)',
    key: 'amount',
    width: '116',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '展示量',
    key: 'pv',
    width: '82',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '点击数',
    key: 'click',
    width: '82',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '点击率',
    key: 'clickRate',
    width: '82',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '平均点击单价',
    key: 'perClickPrice',
    width: '118',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '平均千次展示单价',
    key: 'thousandsOfDisplayCosts',
    width: '142',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '注册数',
    key: 'register',
    width: '82',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '注册成本',
    key: 'registerCost',
    width: '94',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '激活数',
    key: 'activeNum',
    width: '82',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '激活成本',
    key: 'activeCost',
    width: '120',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '激活率',
    key: 'activeRate',
    width: '82',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '转化数',
    key: 'convertNum',
    width: '82',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '转化成本',
    key: 'convertCost',
    width: '120',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '转化率',
    key: 'convertRate',
    width: '82',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '表单提交成功量',
    key: 'aggrFormSubmitSuccess',
    sortable: 'custom',
    width: 124,
    type: 'report'
  },
  {
    title: '表单提交成功成本',
    key: 'aggrFormSubmitSuccessCost',
    sortable: 'custom',
    width: 134,
    type: 'report'
  },
  {
    title: '微信调起按钮点击量',
    key: 'weixinAppButtonConversions',
    sortable: 'custom',
    width: 154,
    type: 'report'
  },
  {
    title: '微信调起按钮点击成本',
    key: 'weixinAppButtonConversionsCost',
    sortable: 'custom',
    width: 154,
    type: 'report'
  },
  {
    title: '微信复制按钮点击量',
    key: 'weixinCopyConversions',
    sortable: 'custom',
    width: 144,
    type: 'report'
  },
  {
    title: '微信复制按钮点击成本',
    key: 'weixinCopyConversionsCost',
    sortable: 'custom',
    width: 154,
    type: 'report'
  },
  {
    title: '微信加粉成功量',
    key: 'weixinFollowSuccessConversions',
    sortable: 'custom',
    width: 134,
    type: 'report'
  },
  {
    title: '微信加粉成功成本',
    key: 'weixinFollowSuccessConversionsCost',
    sortable: 'custom',
    width: 134,
    type: 'report'
  },
  {
    title: '付费行为数',
    key: 'appCheckoutCount',
    width: '110',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '付费金额',
    key: 'payAmount',
    width: '94',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '计划ID',
    key: 'adGroupId',
    width: '142',
    type: 'other'
  },
  {
    title: '媒体',
    key: 'mediaName',
    width: '142',
    type: 'other'
  },
  {
    title: '账号',
    key: 'adAccountName',
    width: '142',
    type: 'other'
  },
  {
    title: '创建时间',
    key: 'createTime',
    width: '120',
    type: 'other'
  },
  {
    title: '同步时间',
    key: 'synTime',
    width: '120',
    type: 'other'
  }
]
export const GROUP_KUAISHOU = [
  {
    title: '开关',
    key: 'switch',
    width: 90,
    type: 'basic',
    fixed: true
  },
  {
    title: '计划',
    key: 'adGroupName',
    width: 270,
    type: 'basic',
    fixed: true
  },
  {
    title: '操作',
    key: 'control',
    width: 80,
    type: 'basic',
    fixed: true
  },
  {
    title: '状态',
    key: 'originStatus',
    type: 'basic',
    width: 90,
    fixed: true
  },
  {
    title: '日预算(元)',
    key: 'budget',
    align: 'right',
    type: 'basic',
    width: 180
  },
  {
    title: '分日预算',
    key: 'day_budget_schedule',
    align: 'right',
    type: 'basic',
    width: 170
  },
  {
    title: '账面消耗(元)',
    key: 'paperAmount',
    type: 'report',
    sortable: 'custom',
    align: 'right',
    width: 120
  },
  {
    title: '实际消耗(元)',
    key: 'amount',
    type: 'report',
    sortable: 'custom',
    align: 'right',
    width: 120
  },
  {
    title: '封面展示量',
    key: 'pv',
    type: 'report',
    sortable: 'custom',
    align: 'right',
    width: 110
  },
  {
    title: '封面点击量',
    key: 'click',
    type: 'report',
    sortable: 'custom',
    align: 'right',
    width: 110
  },
  {
    title: '素材展示量',
    key: 'materialPv',
    type: 'report',
    sortable: 'custom',
    align: 'right',
    width: 110
  },
  {
    title: '封面点击率',
    key: 'clickRate',
    type: 'report',
    sortable: 'custom',
    align: 'right',
    width: 110
  },
  {
    title: '平均封面点击单价',
    key: 'perClickPrice',
    type: 'report',
    sortable: 'custom',
    align: 'right',
    width: 140
  },
  {
    title: '平均千次封面展示均价',
    key: 'thousandsOfDisplayCosts',
    type: 'report',
    sortable: 'custom',
    align: 'right',
    width: 160
  },
  {
    title: '激活数',
    key: 'activeNum',
    sortable: 'custom',
    align: 'right',
    width: 90,
    type: 'report'
  },
  {
    title: '激活成本',
    key: 'activeCost',
    type: 'report',
    sortable: 'custom',
    align: 'right',
    width: 100
  },
  {
    title: '激活率',
    key: 'activeRate',
    type: 'report',
    sortable: 'custom',
    align: 'right',
    width: 90
  },
  {
    title: '注册数',
    key: 'register',
    sortable: 'custom',
    align: 'right',
    width: 90,
    type: 'report'
  },
  {
    title: '注册成本',
    key: 'registerCost',
    sortable: 'custom',
    align: 'right',
    width: 100,
    type: 'report'
  },
  {
    title: '付费次数',
    key: 'payCount',
    type: 'report',
    sortable: 'custom',
    align: 'right',
    width: 100
  },
  {
    title: '付费金额',
    key: 'payAmount',
    type: 'report',
    sortable: 'custom',
    align: 'right',
    width: 100
  },
  {
    title: '计划ID',
    key: 'adGroupId',
    type: 'other',
    width: 120,
    overflow: true
  },
  {
    title: '媒体',
    key: 'mediaName',
    type: 'other',
    width: 120,
    overflow: true
  },
  {
    title: '账号',
    key: 'adAccountName',
    type: 'other',
    width: 120,
    overflow: true
  },
  {
    title: '新建时间',
    key: 'createTime',
    type: 'other',
    width: 140
  },
  {
    title: '同步时间',
    key: 'synTime',
    type: 'other',
    width: 140
  }
]

export const PLAN_TOUTIAO = [
  {
    title: '开关',
    key: 'switch',
    width: '82',
    type: 'basic',
    fixed: true
  },
  {
    title: '投放计划',
    key: 'adName',
    width: '280',
    type: 'basic',
    fixed: true
  },
  {
    title: '状态',
    key: 'status',
    width: '90',
    type: 'basic',
    fixed: true,
    overflow: true
  },
  {
    title: '操作',
    key: 'control',
    width: '130',
    type: 'basic',
    fixed: true
  },
  {
    title: '流量位置',
    key: 'inventoryType',
    width: '200',
    type: 'basic',
    overflow: true
  },
  {
    title: '计划组',
    width: '150',
    key: 'adGroupName',
    type: 'basic',
    overflow: true
  },
  {
    title: '投放时间',
    width: '100',
    key: 'planTime',
    type: 'basic'
  },
  {
    title: '出价方式',
    key: 'bidMode',
    width: '94',
    type: 'basic'
  },
  {
    title: '出价',
    key: 'bid',
    width: '160',
    type: 'basic'
  },
  {
    title: '计划预算',
    key: 'budget',
    width: '180',
    type: 'report'
  },
  {
    title: '账面消耗(元)',
    key: 'paperAmount',
    width: '116',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '实际消耗(元)',
    key: 'amount',
    width: '116',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '展示量',
    key: 'pv',
    width: '82',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '点击数',
    key: 'clickNum',
    width: '82',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '点击率',
    key: 'clickRate',
    width: '82',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '平均点击单价',
    key: 'perClickPrice',
    width: '118',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '平均千次展示单价',
    key: 'thousandsOfDisplayCosts',
    width: '142',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '转化数',
    key: 'convertNum',
    width: '82',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '转化成本',
    key: 'convertCost',
    width: '94',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '转化率',
    key: 'convertRate',
    width: '82',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '激活数',
    key: 'activeNum',
    width: '82',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '激活成本',
    key: 'activeCost',
    width: '94',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '激活率',
    key: 'activeRate',
    width: '82',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '注册数',
    key: 'register',
    width: '82',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '注册成本',
    key: 'registerCost',
    width: '94',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '付费行为数',
    key: 'payCount',
    width: '110',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '付费金额',
    key: 'payAmount',
    width: '94',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '自动化规则',
    key: 'autoRuleNameStr',
    width: '140',
    type: 'other',
    overflow: true
  },
  {
    title: '投放ID',
    key: 'adId',
    width: '140',
    type: 'other',
    overflow: true
  },
  {
    title: '媒体',
    key: 'mediaName',
    width: '80',
    type: 'other',
    overflow: true
  },
  {
    title: '账号',
    key: 'adAccountName',
    width: '140',
    type: 'other',
    overflow: true
  },
  {
    title: '投放游戏',
    key: 'gameName',
    width: '110',
    type: 'other',
    overflow: true
  },
  {
    title: '投放人员',
    key: 'launchOpName',
    width: '80',
    type: 'other',
    overflow: true
  },
  {
    title: '创建时间',
    key: 'createTime',
    width: '120',
    type: 'other'
  },
  {
    title: '同步时间',
    key: 'synTime',
    width: '120',
    type: 'other'
  }
]
export const PLAN_UC = [
  {
    title: '开关',
    key: 'switch',
    width: '82',
    type: 'basic',
    fixed: true
  },
  {
    title: '推广计划',
    key: 'adName',
    width: '280',
    type: 'basic',
    fixed: true
  },
  {
    title: '操作',
    key: 'control',
    width: '130',
    type: 'basic',
    fixed: true
  },
  {
    title: '状态',
    key: 'status',
    width: '90',
    type: 'basic',
    fixed: true,
    overflow: true
  },
  {
    title: '日预算',
    key: 'budget',
    width: '180',
    type: 'basic'
  },
  {
    title: '出价',
    key: 'bid',
    width: '160',
    type: 'basic'
  },
  {
    title: '推广组',
    width: '280',
    key: 'adGroupName',
    type: 'basic',
    overflow: true
  },
  {
    title: '账面消耗(元)',
    key: 'paperAmount',
    width: '116',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '实际消耗(元)',
    key: 'amount',
    width: '116',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '展示量',
    key: 'pv',
    width: '82',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '点击数',
    key: 'clickNum',
    width: '82',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '点击率',
    key: 'clickRate',
    width: '82',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '点击单价',
    key: 'perClickPrice',
    width: '118',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '千次展示均价',
    key: 'thousandsOfDisplayCosts',
    width: '142',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '激活数',
    key: 'activeNum',
    width: '82',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '激活成本',
    key: 'activeCost',
    width: '94',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '转化数',
    key: 'convertNum',
    width: '82',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '转化成本',
    key: 'convertCost',
    width: '94',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '深度转化数',
    key: 'deepBindingNum',
    width: '82',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '深度转化成本',
    key: 'deepBindCost',
    width: '94',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '首日ROI',
    key: 'day1Roi',
    width: '82',
    type: 'report'
  },
  {
    title: '累积ROI',
    key: 'sumRoi',
    width: '82',
    type: 'report'
  },
  {
    title: '自动化规则',
    key: 'autoRuleNameStr',
    width: '140',
    type: 'other',
    overflow: true
  },
  {
    title: '推广计划ID',
    key: 'adId',
    width: '110',
    type: 'other',
    overflow: true
  },
  {
    title: '媒体',
    key: 'mediaName',
    width: '80',
    type: 'other',
    overflow: true
  },
  {
    title: '账号',
    key: 'adAccountName',
    width: '140',
    type: 'other',
    overflow: true
  },
  {
    title: '投放时间',
    width: '100',
    key: 'planTime',
    type: 'basic'
  },
  {
    title: '投放游戏',
    key: 'gameName',
    width: '110',
    type: 'other',
    overflow: true
  },
  {
    title: '管理人员',
    key: 'launchOpName',
    width: '80',
    type: 'other',
    overflow: true
  },
  {
    title: '创建时间',
    key: 'createTime',
    width: '120',
    type: 'other'
  },
  {
    title: '同步时间',
    key: 'synTime',
    width: '120',
    type: 'other'
  }
]
export const PLAN_TENCENT = [
  {
    title: '开关',
    key: 'switch',
    width: '82',
    type: 'basic',
    fixed: true
  },
  {
    title: '计划',
    key: 'adName',
    width: '280',
    type: 'basic',
    fixed: true
  },
  {
    title: '状态',
    key: 'status',
    width: '90',
    type: 'basic',
    fixed: true,
    overflow: true
  },
  {
    title: '操作',
    key: 'control',
    width: '130',
    type: 'basic',
    fixed: true
  },
  {
    title: '推广目的',
    key: 'adResource',
    width: '120',
    type: 'basic',
    overflow: true
  },
  {
    title: '推广计划',
    width: '280',
    key: 'adGroupName',
    type: 'basic',
    overflow: true
  },
  {
    title: '投放时间',
    width: '100',
    key: 'planTime',
    type: 'basic'
  },
  {
    title: '出价方式',
    key: 'bidMode',
    width: '94',
    type: 'basic'
  },
  {
    title: '出价(元)',
    key: 'bid',
    width: '160',
    type: 'basic'
  },
  {
    title: '计划预算',
    key: 'budget',
    width: '180',
    type: 'report'
  },
  {
    title: '账面消耗(元)',
    key: 'paperAmount',
    width: '116',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '实际消耗(元)',
    key: 'amount',
    width: '116',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '展示量',
    key: 'pv',
    width: '82',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '点击数',
    key: 'clickNum',
    width: '82',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '点击率',
    key: 'clickRate',
    width: '82',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '平均点击单价',
    key: 'perClickPrice',
    width: '118',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '平均千次展示单价',
    key: 'thousandsOfDisplayCosts',
    width: '142',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '激活数',
    key: 'activeNum',
    width: '82',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '激活成本',
    key: 'activeCost',
    width: '94',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '激活率',
    key: 'activeRate',
    width: '82',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '转化数',
    key: 'convertNum',
    width: '82',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '转化成本',
    key: 'convertCost',
    width: '94',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '转化率',
    key: 'convertRate',
    width: '82',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '注册数',
    key: 'register',
    width: '82',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '注册成本',
    key: 'registerCost',
    width: '94',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '付费行为数',
    key: 'appCheckoutCount',
    width: '110',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '付费金额',
    key: 'payAmount',
    width: '94',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '商品页浏览量',
    key: 'appCommodityPageViewCount',
    width: '120',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '商品页浏览成本',
    key: 'appCommodityPageViewCost',
    width: '132',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '自动化规则',
    key: 'autoRuleNameStr',
    width: '140',
    type: 'other',
    overflow: true
  },
  {
    title: '计划ID',
    key: 'adId',
    width: '110',
    type: 'other',
    overflow: true
  },
  {
    title: '媒体',
    key: 'mediaName',
    width: '80',
    type: 'other',
    overflow: true
  },
  {
    title: '账号',
    key: 'adAccountName',
    width: '140',
    type: 'other',
    overflow: true
  },
  {
    title: '投放游戏',
    key: 'gameName',
    width: '110',
    type: 'other',
    overflow: true
  },
  {
    title: '投放人员',
    key: 'launchOpName',
    width: '80',
    type: 'other',
    overflow: true
  },
  {
    title: '创建时间',
    key: 'createTime',
    width: '120',
    type: 'other'
  },
  {
    title: '同步时间',
    key: 'synTime',
    width: '120',
    type: 'other'
  }
]
export const PLAN_BAIDU = [
  {
    title: '开关',
    key: 'switch',
    width: '82',
    type: 'basic',
    fixed: true
  },
  {
    title: '推广单元',
    key: 'adName',
    width: '280',
    type: 'basic',
    fixed: true
  },
  {
    title: '状态',
    key: 'status',
    width: '90',
    type: 'basic',
    fixed: true,
    overflow: true
  },
  {
    title: '操作',
    key: 'control',
    width: '130',
    type: 'basic',
    fixed: true
  },
  {
    title: '推广资源',
    key: 'inventoryType',
    width: '120',
    type: 'basic',
    overflow: true
  },
  {
    title: '推广版位',
    key: 'adResource',
    width: '120',
    type: 'basic',
    overflow: true
  },
  {
    title: '推广对象',
    key: 'adResourceId',
    width: '120',
    type: 'basic',
    overflow: true
  },
  {
    title: '推广计划',
    width: '280',
    key: 'adGroupName',
    type: 'basic',
    overflow: true
  },
  {
    title: '投放时间',
    width: '100',
    key: 'planTime',
    type: 'basic'
  },
  {
    title: '出价方式',
    key: 'bidMode',
    width: '94',
    type: 'basic'
  },
  {
    title: '出价(元)',
    key: 'bid2',
    width: '160',
    type: 'basic'
  },
  {
    title: '深度出价(元)',
    key: 'deepCpabid',
    width: '160',
    type: 'basic'
  },
  {
    title: 'Roi系数',
    key: 'roi',
    width: '160',
    type: 'basic'
  },
  {
    title: '优化目标',
    key: 'convertType',
    width: '96',
    type: 'basic'
  },
  {
    title: '深度优化目标',
    key: 'deepConversionType',
    width: '96',
    type: 'basic'
  },
  {
    title: '账面消耗(元)',
    key: 'paperAmount',
    width: '116',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '实际消耗(元)',
    key: 'amount',
    width: '116',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '展示量',
    key: 'pv',
    width: '82',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '点击数',
    key: 'clickNum',
    width: '82',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '点击率',
    key: 'clickRate',
    width: '82',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '平均点击单价',
    key: 'perClickPrice',
    width: '118',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '平均千次展示单价',
    key: 'thousandsOfDisplayCosts',
    width: '142',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '激活数',
    key: 'activeNum',
    width: '82',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '激活成本',
    key: 'activeCost',
    width: '94',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '激活率',
    key: 'activeRate',
    width: '82',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '转化数',
    key: 'convertNum',
    width: '82',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '转化成本',
    key: 'convertCost',
    width: '94',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '转化率',
    key: 'convertRate',
    width: '82',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '注册数',
    key: 'register',
    width: '82',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '注册成本',
    key: 'registerCost',
    width: '94',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '付费行为数',
    key: 'appCheckoutCount',
    width: '110',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '付费金额',
    key: 'payAmount',
    width: '94',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '自动化规则',
    key: 'autoRuleNameStr',
    width: '140',
    type: 'other',
    overflow: true
  },
  {
    title: '计划ID',
    key: 'adId',
    width: '110',
    type: 'other',
    overflow: true
  },
  {
    title: '媒体',
    key: 'mediaName',
    width: '80',
    type: 'other',
    overflow: true
  },
  {
    title: '账号',
    key: 'adAccountName',
    width: '140',
    type: 'other',
    overflow: true
  },
  {
    title: '投放游戏',
    key: 'gameName',
    width: '110',
    type: 'other',
    overflow: true
  },
  {
    title: '投放人员',
    key: 'launchOpName',
    width: '80',
    type: 'other',
    overflow: true
  },
  {
    title: '创建时间',
    key: 'createTime',
    width: '120',
    type: 'other'
  },
  {
    title: '同步时间',
    key: 'synTime',
    width: '120',
    type: 'other'
  }
]
export const PLAN_KUAISHOU = [
  {
    title: '开关',
    key: 'switch',
    width: 90,
    type: 'basic',
    fixed: true
  },
  {
    title: '计划组',
    key: 'adName',
    width: 280,
    type: 'basic',
    fixed: true
  },
  {
    title: '状态',
    key: 'status',
    type: 'basic',
    width: 100,
    fixed: true
  },
  {
    title: '操作',
    key: 'control',
    width: 110,
    type: 'basic',
    fixed: true
  },
  {
    title: '优化目标',
    key: 'ocpxActionType',
    width: 120,
    type: 'basic'
  },
  {
    title: '深度转化目标',
    key: 'deepConversionType',
    width: 100,
    type: 'basic'
  },
  {
    title: '推广计划',
    key: 'adGroupName',
    width: 180,
    type: 'basic'
  },
  {
    title: '投放时间',
    key: 'planTime',
    width: 100,
    type: 'basic'
  },
  {
    title: '出价方式',
    key: 'bidMode',
    width: 90,
    type: 'basic'
  },
  {
    title: '出价(元)',
    key: 'bid',
    align: 'right',
    width: 160,
    type: 'basic'
  },
  {
    title: '深度出价(元)',
    key: 'bid2',
    align: 'right',
    width: 160,
    type: 'basic'
  },
  {
    title: 'ROI系数',
    key: 'roi',
    align: 'right',
    width: 160,
    type: 'basic'
  },
  {
    title: '日预算(元)',
    key: 'budget',
    align: 'right',
    width: 180,
    type: 'basic'
  },
  {
    title: '分日预算',
    key: 'day_budget_schedule',
    align: 'right',
    type: 'basic',
    width: 170
  },
  {
    title: '账面消耗(元)',
    key: 'paperAmount',
    sortable: 'custom',
    align: 'right',
    width: 120,
    type: 'report'
  },
  {
    title: '实际消耗(元)',
    key: 'amount',
    sortable: 'custom',
    align: 'right',
    width: 120,
    type: 'report'
  },
  {
    title: '封面展示量',
    key: 'pv',
    sortable: 'custom',
    align: 'right',
    width: 110,
    type: 'report'
  },
  {
    title: '封面点击量',
    key: 'clickNum',
    sortable: 'custom',
    align: 'right',
    width: 110,
    type: 'report'
  },
  {
    title: '素材展示量',
    key: 'materialPv',
    type: 'report',
    sortable: 'custom',
    align: 'right',
    width: 110
  },
  {
    title: '封面点击率',
    key: 'clickRate',
    sortable: 'custom',
    align: 'right',
    width: 110,
    type: 'report'
  },
  {
    title: '平均封面点击单价',
    key: 'perClickPrice',
    sortable: 'custom',
    align: 'right',
    width: 140,
    type: 'report'
  },
  {
    title: '平均千次封面展示均价',
    key: 'thousandsOfDisplayCosts',
    sortable: 'custom',
    align: 'right',
    width: 160,
    type: 'report'
  },
  {
    title: '激活数',
    key: 'activeNum',
    sortable: 'custom',
    align: 'right',
    width: 90,
    type: 'report'
  },
  {
    title: '激活成本',
    key: 'activeCost',
    sortable: 'custom',
    align: 'right',
    width: 100,
    type: 'report'
  },
  {
    title: '激活率',
    key: 'activeRate',
    sortable: 'custom',
    align: 'right',
    width: 90,
    type: 'report'
  },
  {
    title: '注册数',
    key: 'register',
    sortable: 'custom',
    align: 'right',
    width: 90,
    type: 'report'
  },
  {
    title: '注册成本',
    key: 'registerCost',
    sortable: 'custom',
    align: 'right',
    width: 100,
    type: 'report'
  },
  {
    title: '付费行为数',
    key: 'payCount',
    sortable: 'custom',
    align: 'right',
    width: 110,
    type: 'report'
  },
  {
    title: '付费金额',
    key: 'payAmount',
    sortable: 'custom',
    align: 'right',
    width: 110,
    type: 'report'
  },
  {
    title: '自动化规则',
    key: 'autoRuleNameStr',
    width: '140',
    type: 'other',
    overflow: true
  },
  {
    title: '计划组ID',
    key: 'adId',
    type: 'other',
    width: 120,
    overflow: true
  },
  {
    title: '媒体',
    key: 'mediaName',
    type: 'other',
    width: 120,
    overflow: true
  },
  {
    title: '账号',
    key: 'adAccountName',
    type: 'other',
    width: 120,
    overflow: true
  },
  {
    title: '投放游戏',
    key: 'gameName',
    type: 'other',
    width: 120,
    overflow: true
  },
  {
    title: '投放人员',
    key: 'launchOpName',
    type: 'other',
    width: 90
  },
  {
    title: '新建时间',
    key: 'createTime',
    type: 'other',
    width: 140
  },
  {
    title: '同步时间',
    key: 'synTime',
    type: 'other',
    width: 140
  }
]

export const IDEA_TOUTIAO = [
  {
    title: '开关',
    key: 'switch',
    width: '82',
    type: 'basic',
    fixed: true
  },
  {
    title: '创意ID',
    key: 'creativeId',
    width: '128',
    type: 'basic',
    fixed: true
  },
  {
    title: '创意',
    key: 'creative',
    width: '260',
    type: 'basic',
    fixed: true
  },
  {
    title: '状态',
    key: 'status',
    width: '120',
    type: 'basic',
    fixed: true,
    overflow: true
  },
  {
    title: '操作',
    key: 'control',
    width: '55',
    type: 'basic',
    fixed: true
  },
  {
    title: '流量位置',
    key: 'inventory',
    width: '200',
    type: 'basic',
    overflow: true
  },
  {
    title: '计划组',
    key: 'adGroupName',
    width: '150',
    type: 'basic',
    overflow: true
  },
  {
    title: '计划',
    key: 'adName',
    width: '180',
    type: 'basic',
    overflow: true
  },
  {
    title: '账面消耗(元)',
    key: 'paperAmount',
    width: '116',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '实际消耗(元)',
    key: 'amount',
    width: '116',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '展示量',
    key: 'pv',
    width: '82',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '点击数',
    key: 'click',
    width: '82',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '点击率',
    key: 'clickRate',
    width: '82',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '平均点击单价',
    key: 'perClickPrice',
    width: '118',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '平均千次展示单价',
    key: 'thousandsOfDisplayCosts',
    width: '142',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '转化数',
    key: 'convertNum',
    width: '82',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '转化成本',
    key: 'convertCost',
    width: '94',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '转化率',
    key: 'convertRate',
    width: '82',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '激活数',
    key: 'activeNum',
    width: '82',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '激活成本',
    key: 'activeCost',
    width: '94',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '激活率',
    key: 'activeRate',
    width: '82',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '注册数',
    key: 'register',
    width: '82',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '注册成本',
    key: 'registerCost',
    width: '94',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '付费行为数',
    key: 'payCount',
    width: '110',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '付费金额',
    key: 'payAmount',
    width: '94',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '投放游戏',
    key: 'gameName',
    width: '110',
    type: 'other',
    overflow: true
  },
  {
    title: '投放人员',
    key: 'launchOpName',
    width: '80',
    type: 'other',
    overflow: true
  },
  {
    title: '媒体',
    key: 'mediaName',
    width: '80',
    type: 'other',
    overflow: true
  },
  {
    title: '账号',
    key: 'adAccountName',
    width: '140',
    type: 'other',
    overflow: true
  },
  {
    title: '创建时间',
    key: 'createTime',
    width: '120',
    type: 'other'
  },
  {
    title: '同步时间',
    key: 'synTime',
    width: '120',
    type: 'other'
  }
]
export const IDEA_UC = [
  {
    title: '开关',
    key: 'switch',
    width: '82',
    type: 'basic',
    fixed: true
  },
  {
    title: '创意',
    key: 'creative',
    width: '260',
    type: 'basic',
    fixed: true
  },
  {
    title: '操作',
    key: 'control',
    width: '55',
    type: 'basic',
    fixed: true
  },
  {
    title: '推广计划',
    key: 'adName',
    width: '180',
    type: 'basic',
    overflow: true
  },
  {
    title: '状态',
    key: 'status',
    width: '120',
    type: 'basic',
    fixed: true,
    overflow: true
  },
  {
    title: '账面消耗(元)',
    key: 'paperAmount',
    width: '116',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '实际消耗(元)',
    key: 'amount',
    width: '116',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '展示量',
    key: 'pv',
    width: '82',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '点击量',
    key: 'click',
    width: '82',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '点击单价',
    key: 'perClickPrice',
    width: '118',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '千次展示均价',
    key: 'thousandsOfDisplayCosts',
    width: '142',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '激活数',
    key: 'activeNum',
    width: '82',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '激活成本',
    key: 'activeCost',
    width: '94',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '转化数',
    key: 'convertNum',
    width: '82',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '转化成本',
    key: 'convertCost',
    width: '94',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '深度转化数',
    key: 'deepBindingNum',
    width: '82',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '深度转化成本',
    key: 'deepBindCost',
    width: '94',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '首日ROI',
    key: 'day1Roi',
    width: '82',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '累计ROI',
    key: 'sumRoi',
    width: '94',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '媒体',
    key: 'mediaName',
    width: '80',
    type: 'other',
    overflow: true
  },
  {
    title: '账号',
    key: 'adAccountName',
    width: '140',
    type: 'other',
    overflow: true
  },
  {
    title: '投放游戏',
    key: 'gameName',
    width: '110',
    type: 'other',
    overflow: true
  },
  {
    title: '投放人员',
    key: 'launchOpName',
    width: '80',
    type: 'other',
    overflow: true
  },
  {
    title: '创建时间',
    key: 'createTime',
    width: '120',
    type: 'other'
  },
  {
    title: '同步时间',
    key: 'synTime',
    width: '120',
    type: 'other'
  }
]
export const IDEA_TENCENT = [
  {
    title: '开关',
    key: 'switch',
    width: '82',
    type: 'basic',
    fixed: true
  },
  {
    title: '创意名称/ID',
    key: 'creativeId',
    width: '240',
    type: 'basic',
    fixed: true
  },
  {
    title: '创意',
    key: 'creative',
    width: '260',
    type: 'basic',
    fixed: true
  },
  {
    title: '状态',
    key: 'status',
    width: '120',
    type: 'basic',
    fixed: true,
    overflow: true
  },
  {
    title: '操作',
    key: 'control',
    width: '55',
    type: 'basic',
    fixed: true
  },
  {
    title: '推广计划',
    key: 'adGroupName',
    width: '150',
    type: 'basic',
    overflow: true
  },
  {
    title: '计划',
    key: 'adName',
    width: '180',
    type: 'basic',
    overflow: true
  },
  {
    title: '账面消耗(元)',
    key: 'paperAmount',
    width: '116',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '实际消耗(元)',
    key: 'amount',
    width: '116',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '展示量',
    key: 'pv',
    width: '82',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '点击数',
    key: 'click',
    width: '82',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '点击率',
    key: 'clickRate',
    width: '82',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '平均点击单价',
    key: 'perClickPrice',
    width: '118',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '平均千次展示单价',
    key: 'thousandsOfDisplayCosts',
    width: '142',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '激活数',
    key: 'activeNum',
    width: '82',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '激活成本',
    key: 'activeCost',
    width: '94',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '激活率',
    key: 'activeRate',
    width: '82',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '转化数',
    key: 'convertNum',
    width: '82',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '转化成本',
    key: 'convertCost',
    width: '94',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '转化率',
    key: 'convertRate',
    width: '82',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '注册数',
    key: 'register',
    width: '82',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '注册成本',
    key: 'registerCost',
    width: '94',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '付费行为数',
    key: 'appCheckoutCount',
    width: '110',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '付费金额',
    key: 'payAmount',
    width: '94',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '落地页',
    key: 'pageUrl',
    width: '280',
    type: 'report',
    overflow: true
  },
  {
    title: '媒体',
    key: 'mediaName',
    width: '80',
    type: 'other',
    overflow: true
  },
  {
    title: '账号',
    key: 'adAccountName',
    width: '140',
    type: 'other',
    overflow: true
  },
  {
    title: '投放游戏',
    key: 'gameName',
    width: '110',
    type: 'other',
    overflow: true
  },
  {
    title: '投放人员',
    key: 'launchOpName',
    width: '80',
    type: 'other',
    overflow: true
  },
  {
    title: '创建时间',
    key: 'createTime',
    width: '120',
    type: 'other'
  },
  {
    title: '同步时间',
    key: 'synTime',
    width: '120',
    type: 'other'
  }
]
export const IDEA_BAIDU = [
  {
    title: '开关',
    key: 'switch',
    width: '82',
    type: 'basic',
    fixed: true
  },
  {
    title: '创意名称/ID',
    key: 'creativeId',
    width: '240',
    type: 'basic',
    fixed: true
  },
  {
    title: '创意',
    key: 'creative',
    width: '260',
    type: 'basic',
    fixed: true
  },
  {
    title: '状态',
    key: 'status',
    width: '120',
    type: 'basic',
    fixed: true,
    overflow: true
  },
  {
    title: '操作',
    key: 'control',
    width: '55',
    type: 'basic',
    fixed: true
  },
  {
    title: '推广计划',
    key: 'adGroupName',
    width: '150',
    type: 'basic',
    overflow: true
  },
  {
    title: '推广单元',
    key: 'adName',
    width: '180',
    type: 'basic',
    overflow: true
  },
  {
    title: '账面消耗(元)',
    key: 'paperAmount',
    width: '116',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '实际消耗(元)',
    key: 'amount',
    width: '116',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '展示量',
    key: 'pv',
    width: '82',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '点击数',
    key: 'click',
    width: '82',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '点击率',
    key: 'clickRate',
    width: '82',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '平均点击单价',
    key: 'perClickPrice',
    width: '118',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '平均千次展示单价',
    key: 'thousandsOfDisplayCosts',
    width: '142',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '激活数',
    key: 'activeNum',
    width: '82',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '激活成本',
    key: 'activeCost',
    width: '94',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '激活率',
    key: 'activeRate',
    width: '82',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '转化数',
    key: 'convertNum',
    width: '82',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '转化成本',
    key: 'convertCost',
    width: '94',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '转化率',
    key: 'convertRate',
    width: '82',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '注册数',
    key: 'register',
    width: '82',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '注册成本',
    key: 'registerCost',
    width: '94',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '付费行为数',
    key: 'appCheckoutCount',
    width: '110',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '付费金额',
    key: 'payAmount',
    width: '94',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '媒体',
    key: 'mediaName',
    width: '80',
    type: 'other',
    overflow: true
  },
  {
    title: '账号',
    key: 'adAccountName',
    width: '140',
    type: 'other',
    overflow: true
  },
  {
    title: '投放游戏',
    key: 'gameName',
    width: '110',
    type: 'other',
    overflow: true
  },
  {
    title: '投放人员',
    key: 'launchOpName',
    width: '80',
    type: 'other',
    overflow: true
  },
  {
    title: '创建时间',
    key: 'createTime',
    width: '120',
    type: 'other'
  },
  {
    title: '同步时间',
    key: 'synTime',
    width: '120',
    type: 'other'
  }
]
export const IDEA_KUAISHOU = [
  {
    title: '开关',
    key: 'switch',
    width: 90,
    type: 'basic',
    fixed: true
  },
  {
    title: '创意名称',
    key: 'creative',
    fixed: true,
    type: 'basic',
    width: 280
  },
  {
    title: '状态',
    key: 'status',
    width: 100,
    type: 'basic',
    fixed: true
  },
  {
    title: '操作',
    key: 'control',
    width: 70,
    type: 'basic',
    fixed: true
  },
  {
    title: '计划计划',
    key: 'adGroupName',
    width: 180,
    type: 'basic'
  },
  {
    title: '计划组',
    key: 'adName',
    width: 160,
    type: 'basic'
  },
  {
    title: '账面消耗(元)',
    key: 'paperAmount',
    sortable: 'custom',
    align: 'right',
    width: 120,
    type: 'report'
  },
  {
    title: '实际消耗(元)',
    key: 'amount',
    sortable: 'custom',
    align: 'right',
    width: 120,
    type: 'report'
  },
  {
    title: '封面展示量',
    key: 'pv',
    sortable: 'custom',
    align: 'right',
    width: 110,
    type: 'report'
  },
  {
    title: '封面点击量',
    key: 'click',
    sortable: 'custom',
    align: 'right',
    width: 110,
    type: 'report'
  },
  {
    title: '素材展示量',
    key: 'materialPv',
    type: 'report',
    sortable: 'custom',
    align: 'right',
    width: 110
  },
  {
    title: '封面点击率',
    key: 'clickRate',
    sortable: 'custom',
    align: 'right',
    width: 110,
    type: 'report'
  },
  {
    title: '平均封面点击单价',
    key: 'perClickPrice',
    sortable: 'custom',
    align: 'right',
    width: 140,
    type: 'report'
  },
  {
    title: '平均千次封面展示均价',
    key: 'thousandsOfDisplayCosts',
    sortable: 'custom',
    align: 'right',
    width: 160,
    type: 'report'
  },
  {
    title: '激活数',
    key: 'activeNum',
    sortable: 'custom',
    align: 'right',
    width: 90,
    type: 'report'
  },
  {
    title: '激活成本',
    key: 'activeCost',
    sortable: 'custom',
    align: 'right',
    width: 100,
    type: 'report'
  },
  {
    title: '激活率',
    key: 'activeRate',
    sortable: 'custom',
    align: 'right',
    width: 90,
    type: 'report'
  },
  {
    title: '注册数',
    key: 'register',
    sortable: 'custom',
    align: 'right',
    width: 90,
    type: 'report'
  },
  {
    title: '注册成本',
    key: 'registerCost',
    sortable: 'custom',
    align: 'right',
    width: 100,
    type: 'report'
  },
  {
    title: '付费行为数',
    key: 'payCount',
    sortable: 'custom',
    align: 'right',
    width: 110,
    type: 'report'
  },
  {
    title: '付费金额',
    key: 'payAmount',
    sortable: 'custom',
    align: 'right',
    width: 110,
    type: 'report'
  },
  {
    title: '创意ID',
    key: 'creativeId',
    type: 'other',
    width: 120,
    overflow: true
  },
  {
    title: '媒体',
    key: 'mediaName',
    type: 'other',
    width: 120,
    overflow: true
  },
  {
    title: '账号',
    key: 'adAccountName',
    type: 'other',
    width: 120,
    overflow: true
  },
  {
    title: '投放游戏',
    key: 'gameName',
    type: 'other',
    width: 120,
    overflow: true
  },
  {
    title: '投放人员',
    key: 'launchOpName',
    type: 'other',
    width: 90
  },
  {
    title: '新建时间',
    key: 'createTime',
    type: 'other',
    width: 140
  },
  {
    title: '同步时间',
    key: 'synTime',
    type: 'other',
    width: 140
  }
]
